import { render, staticRenderFns } from "./DashboardNivelTensaoVisaoMunicipios.vue?vue&type=template&id=6be58517&"
import script from "./DashboardNivelTensaoVisaoMunicipios.vue?vue&type=script&lang=js&"
export * from "./DashboardNivelTensaoVisaoMunicipios.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNivelTensaoVisaoMunicipios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VCol,VRow,VSelect,VSpacer,VTooltip})
